import * as React from "react";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { useGetDispatchDate } from "@grandvisionhq/shipping";
import { PICKUP_POINTS_BY_GEO_LOCATION } from "../../operations/queries/operations/queries/pickup-points-by-geo-location.js";
import { PICKUP_POINTS_BY_POSTAL_CODE } from "../../operations/queries/operations/queries/pickup-points-by-postal-code.js";
const SHIPPING_METHOD_KEY = "pick-up-point";
const filterNullable = (points) => points.filter((p) => p !== null);
function useGetPickupPoints(itemsToBeShipped) {
  const [data, setData] = React.useState(null);
  const [error, setError] = React.useState(null);
  const onError = (err) => {
    setError(err);
  };
  const [getByGeoLocation, geoResult] = useLazyQuery(PICKUP_POINTS_BY_GEO_LOCATION, { onError });
  const [getByPostalCode, formResult] = useLazyQuery(PICKUP_POINTS_BY_POSTAL_CODE, { onError });
  const { dispatchDate } = useGetDispatchDate(itemsToBeShipped ?? [], SHIPPING_METHOD_KEY);
  const getPickupPoints = React.useCallback(
    ({ userCoords, formState }) => {
      if (userCoords) {
        getByGeoLocation({
          variables: {
            geoLocation: {
              lat: userCoords.latitude,
              lon: userCoords.longitude
            },
            shippingDate: dispatchDate
          }
        });
      } else if (formState?.postalCode) {
        getByPostalCode({
          variables: {
            postalCodeInput: {
              postalCode: formState.postalCode,
              city: formState?.city
              // City is not required by some OpCos
            },
            shippingDate: dispatchDate
          }
        });
      } else {
        console.error("Need either user coords or postalCode and city to fetch pickup points!");
      }
    },
    [getByGeoLocation, getByPostalCode, dispatchDate]
  );
  React.useEffect(() => {
    const pickupPoints = geoResult.data?.pickupPointsByGeoLocation;
    if (pickupPoints) {
      setError(null);
      setData(filterNullable(pickupPoints));
    }
  }, [geoResult.data]);
  React.useEffect(() => {
    const pickupPoints = formResult.data?.pickupPointsByPostalCode;
    if (pickupPoints) {
      setError(null);
      setData(filterNullable(pickupPoints));
    }
  }, [formResult.data]);
  const called = geoResult.called || formResult.called;
  const loading = geoResult.loading || formResult.loading;
  const noResultsFound = called && !loading && Array.isArray(data) && data.length === 0;
  return [
    getPickupPoints,
    {
      loading,
      error: error !== null ? error : void 0,
      noResultsFound,
      pickupPoints: data ?? []
    }
  ];
}
export {
  useGetPickupPoints
};
//# sourceMappingURL=use-get-pickup-points.js.map
